/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import { mappingCashReceipts, mappingToEtcInvoice } from "../../../apis/invoices";
import { getParams } from "../../../utils/params";
import { getDay } from "../../../utils/date";
import useForm from "../../../hooks/useForm";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import Modal, { ModalHeader } from "../../../components/Modal";
import Button from "../../../components/Button";
import systemAlert from "../../../utils/systemAlert";
import { toast } from "../../../utils/toast";
import { getCashReceiptsPurchaseList, getCashReceiptsSalesList } from "../../../apis/cash-receipts";

const CashInvoiceMapping = ({
  open,
  setOpen,
  data,
  setData,
  type,
  listSubmit,
  requesterType = "invoice"
}) => {
  const history = useHistory();
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (open) {
      setFields([
        { title: "거래일자", key: "tradeTime", type: "date" },
        { title: "승인번호", key: "apprNo" },
        { title: "발급수단번호", key: "frPartNo" },
        { title: "거래구분", key: "trGb" },
        { isHide: type === 'sales', title: "공제구분", key: "ddcYn" },
        { title: "공급가액", key: "supAmt", type: 'comma' },
        { title: "부가세", key: "taxAmt", type: 'comma' },
        { title: "봉사료", key: "tip", type: 'comma' },
        { title: "총 거래금액", key: "totAmt", type: 'comma' },
      ]);
    }
  }, [open]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    order: [{ tradeTime: "desc" }],
    range: {
      tradeTime: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date,
    },
    page: 0,
    limit: 10
  });

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, [requesterType]);

  const submit = (params) => {
    const type = params.type || "sales";
    setIsLoading(true);
    switch (type) {
      case 'sales':
        getCashReceiptsSalesList(getParams(params))
          .then((res) => {
            setList(res.data.list);
            setTotal(res.data.totalCount);
          })
          .catch(() => { })
          .finally(() => {
            setIsLoading(false);
          });
        break;
      case 'purchase':
        getCashReceiptsPurchaseList(getParams(params))
          .then((res) => {
            setList(res.data.list);
            setTotal(res.data.totalCount);
          })
          .catch(() => { })
          .finally(() => {
            setIsLoading(false);
          });
        break;
      default:
        break;
    }
  };

  const filters = [
    {
      isHide: requesterType === "invoice", title: "구분", type: "select",
      key: "type",
      options: {
        list: [{
          label: "매출",
          value: "sales",
        },
        {
          label: "매입",
          value: "purchase",
        }]
      }
    },
    { title: "조회기간", key: "range.tradeTime", type: "customdatepicker" },
  ];

  const cancel = () => {
    setData(null);
    setOpen(false);
  };

  const handleOnSupply = () => {
    if (isEmpty(selectedList)) return toast.error('현금영수증을 선택해주세요');
    let body;
    switch (requesterType) {
      case "order":
      case "quotation":
        body = {
          list: selectedList.map((li) => ({
            requestIdx: data.idx,
            mappingIdx: li.idx
          })),
          cashReceipt: form.type || "sales"
        };
        systemAlert(`해당${requesterType === "quotation" ? "견적서" : "발주서"}에 선택된 현금영수증을 매핑 하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                mappingToEtcInvoice("cashReceipt", requesterType, body)
                  .then(() => {
                    listSubmit();
                    cancel();
                  });
              }
            }
          ]
        });
        break;

      case "invoice":
        body = {
          list: selectedList.map((li) => ({
            invoiceIdx: data.idx,
            cashReceiptType: type,
            cashReceiptIdx: li.idx
          }))
        };

        systemAlert('해당 거래명세서에 선택된 현금영수증을 매핑 하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                mappingCashReceipts(body)
                  .then(() => {
                    listSubmit();
                    cancel();
                  });
              }
            }
          ]
        });
        break;
      default:
        break;
    }

  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="select-tax-invoice-container">
        <ModalHeader>현금영수증 매핑하기</ModalHeader>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange} />
        <ControlTable
          isControl
          isHideAllCheck
          fields={fields}
          list={list}
          selectedList={selectedList}
          setSelected={setSelectedList}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleOnSupply}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CashInvoiceMapping;
